// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 23 ? "bundle" : chunkId) + "." + __webpack_require__.h() + ".js";
};